<template>
  <div>
    <authentication-forms-container :image="image">
      <b-form @submit.prevent="onSubmit" class="mt-2">
        <h4 class="text-primary">تغییر رمز عبور</h4>

        <b-form-row>
          <b-col>
            <form-group :validations="$v.form.code">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-1"
                    label="کد ارسال شده به تلفن همراه"
                    label-for="input-1"
                    class="mb-4 mt-3"
                >
                <span class="badge badge-primary px-2 mb-2"
                >زمان باقی مانده {{ timerCount }}
              </span>
                  <b-form-input
                      v-model="form.code"
                      id="input-1"
                      type="text"
                      placeholder="...کد ارسال شده به تلفن همراه را وارد نمایید"
                      class="rounded-pill text-left"
                      :class="{ invalid }"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <form-group :validations="$v.form.password">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-4"
                    label="کلمه عبور"
                    label-for="input-4"
                    class="mb-4"
                >
                  <b-form-input
                      v-model="form.password"
                      type="password"
                      id="input-4"
                      placeholder="حداقل ۸ کاراکتر وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>

          <b-col>
            <form-group :validations="$v.form.password_confirmation">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-5"
                    label="تکرار کلمه عبور"
                    label-for="input-5"
                    class="mb-4"
                >
                  <b-form-input
                      v-model="form.password_confirmation"
                      type="password"
                      id="input-5"
                      placeholder="حداقل ۸ کاراکتر وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
        </b-form-row>

        <b-button block pill type="submit" class="my-3 w-100" variant="primary"
        >تایید
        </b-button>
        <a class="text-primary"
            href="#"
            v-if="timerCount === 0"
            @click.prevent="resendCellphoneCodeForForgetPassword"
        >ارسال مجدد کد</a
        >
      </b-form>
    </authentication-forms-container>
  </div>
</template>

<script>
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import {sameAs, required, minLength} from "vuelidate/lib/validators";
import FormErrorsManager from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import {mapGetters} from "vuex";
import AuthenticationFormsContainer from "../../AuthenticationFormsContainer/AuthenticationFormsContainer.vue";

export default {
  name: "CellphoneForgetPassword1",
  components: {FormGroup, FormErrorsManager, AuthenticationFormsContainer},
  data() {
    return {
      form: {
        code: "",
        password: "",
        password_confirmation: "",
      },
      timerEnabled: true,
      timerCount: 120,
    };
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      }
    },

    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  props: {
    image: {
      type: String,
      default: require('../../assets/login.png')
    }
  },
  validations: {
    form: {
      code: {required},
      password: {required, minLength: minLength(8)},
      password_confirmation: {required, sameAsPassword: sameAs("password")},
    },
  },
  computed: {
    ...mapGetters({
      cellphon: "Authentication/getCellphoneForForgetPassword",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        let c = {
          cellphone: this.cellphon.cellphone,
          code: this.form.code,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
        };
        this.$store.dispatch("Authentication/cellphoneResetPassword", c);
      }
    },

    resendCellphoneCodeForForgetPassword() {
      const c = {cellphone: this.cellphon.cellphone};
      this.$store.dispatch("Authentication/resendCodeForCellphoneForgetPassword", c);
      this.resetTimer();
    },

    play() {
      this.timerEnabled = true;
    },

    pause() {
      this.timerEnabled = false;
    },
    resetTimer() {
      this.timerCount = 120;
      this.timerEnabled = true;
    },
  },
};
</script>
<style scoped>

</style>